import { Component, h, Prop } from '@stencil/core';
import { Localization, WidgetInstance } from 'friendly-challenge';

@Component({
  tag: 'sofistik-friendly-captcha',
  styleUrl: 'friendly-captcha.scss',
})
export class FriendlyCaptcha {
  @Prop() siteKey: string;

  @Prop() widgetLanguage: string;

  containerDiv!: HTMLDivElement;

  widget!: WidgetInstance;

  async componentDidLoad() {
    this.widget = new WidgetInstance(this.containerDiv, {
      startMode: 'auto',
      sitekey: this.siteKey,
      language: this.widgetLanguage as unknown as Localization,
    });
  }

  async disconnectedCallback() {
    this.widget.destroy();
  }

  render() {
    return <div ref={el => (this.containerDiv = el as HTMLDivElement)} class="frc-captcha"></div>;
  }
}
